import { render, staticRenderFns } from "./resourceList.vue?vue&type=template&id=06ae65d1&scoped=true&"
import script from "./resourceList.vue?vue&type=script&lang=js&"
export * from "./resourceList.vue?vue&type=script&lang=js&"
import style0 from "./resourceList.vue?vue&type=style&index=0&id=06ae65d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ae65d1",
  null
  
)

export default component.exports